/* Sleepee A+ v2 (defer): slider kolorów P6, hotspoty P2 (hover/klik + dymek), kategoria: suwak TOG C4 (wynik, tabela, CTA → filtr tagu),
   zakładki chooser C4, wiersze tabeli C5 jako linki.
   Bez JS wszystko jest widoczne i przewijalne — skrypt tylko dodaje wygodę. */
(function () {
  'use strict';
  function initSlider(root) {
    var track = root.querySelector('[data-track]');
    if (!track) return;
    var prev = root.querySelector('.sl-ap-arr.prev'), next = root.querySelector('.sl-ap-arr.next');
    var step = function () { var s = track.querySelector('.sl-ap-slide'); return s ? s.offsetWidth + 16 : 240; };
    var sync = function () {
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    };
    root.querySelectorAll('.sl-ap-arr').forEach(function (b) {
      b.addEventListener('click', function () { track.scrollBy({ left: step() * 2 * (+b.dataset.dir || 1), behavior: 'smooth' }); });
    });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    setTimeout(sync, 60);
    var cur = track.querySelector('.sl-ap-slide--cur');
    if (cur && cur.offsetLeft > track.clientWidth - cur.offsetWidth) track.scrollLeft = cur.offsetLeft - 16;
  }
  function initAnat(root) {
    var items = root.querySelectorAll('[data-h]');
    var set = function (n) {
      items.forEach(function (e) { e.classList.toggle('on', !!n && e.dataset.h === n); });
      root.classList.toggle('focus', !!n);
    };
    items.forEach(function (e) {
      e.addEventListener('mouseenter', function () { set(e.dataset.h); });
      e.addEventListener('click', function () { set(e.classList.contains('on') ? null : e.dataset.h); });
    });
    root.addEventListener('mouseleave', function () { set(null); });
  }
  function initTog(root) {
    var tr = root.querySelector('input[type=range]');
    var bands = JSON.parse(root.dataset.bands || '[]'), rows = JSON.parse(root.dataset.rows || '[]'), urls = JSON.parse(root.dataset.urls || '{}');
    var rng = {}; rows.forEach(function (r) { rng[r.tog] = r.range; });
    var out = root.querySelector('[data-temp]'), togOut = root.querySelector('[data-tog]'), txt = root.querySelector('[data-txt]'), cta = root.querySelector('[data-togcta]');
    var btns = root.querySelectorAll('[data-tog-row]');
    var fromTemp = function () {
      if (!tr || !bands.length) return rows[0] && rows[0].tog;
      var v = parseFloat(tr.value), b = bands.filter(function (b) { return v >= b[1] && v < b[2]; })[0] || bands[bands.length - 1];
      return b[0];
    };
    var upd = function (t) {
      t = t || fromTemp();
      if (out && tr) out.textContent = String(parseFloat(tr.value)).replace('.5', ',5').replace(',5', '.5') + '\u00a0\u00b0C';
      if (togOut) togOut.textContent = t + ' TOG';
      /* 6.10: zakres bez stopni (np. „TBC”) nie jest zakresem — nie pokazujemy zdania z dopiskiem roboczym */
      if (txt) txt.textContent = (rng[t] || '').indexOf('°') > -1 ? (root.dataset.result || '').replace('{range}', rng[t]) : '';
      btns.forEach(function (b) { b.classList.toggle('on', b.dataset.togRow === t); });
      if (cta) { cta.textContent = (root.dataset.cta || '').replace('{tog}', t); if (urls[t]) cta.href = urls[t]; }
    };
    if (tr) tr.addEventListener('input', function () { upd(); });
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var t = b.dataset.togRow, bd = bands.filter(function (x) { return x[0] === t; })[0];
        if (bd && tr) { tr.value = (bd[1] + bd[2]) / 2; upd(); } else upd(t);
      });
    });
    upd();
  }
  function initChooser(root) {
    var tabs = root.querySelectorAll('[data-ch]'), panels = root.querySelectorAll('[data-ch-panel]');
    var show = function (i) {
      tabs.forEach(function (t) { var on = t.dataset.ch === i; t.classList.toggle('on', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
      panels.forEach(function (p) { p.hidden = p.dataset.chPanel !== i; });
    };
    tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.ch); }); });
  }
  function initTableLinks(root) {
    root.querySelectorAll('tr[data-href]').forEach(function (tr) {
      tr.addEventListener('click', function (e) { if (e.target.closest('a')) return; window.location.href = tr.dataset.href; });
    });
  }
  function init() {
    document.querySelectorAll('[data-aplus-slider]').forEach(initSlider);
    document.querySelectorAll('[data-aplus-anat]').forEach(initAnat);
    document.querySelectorAll('[data-aplus-tog]').forEach(initTog);
    document.querySelectorAll('[data-aplus-chooser]').forEach(initChooser);
    document.querySelectorAll('.sl-ap-ftable').forEach(initTableLinks);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
